import { IStyle } from '@fluentui/react';
import { IH2OTheme } from '@h2oai/ui-kit';

export interface IIngestPanelStyles {
  root?: IStyle;
}

export interface IIngestPanelClassNames {
  root: string;
}

export const ingestPanelStylesDefault = (_theme: IH2OTheme): Partial<IIngestPanelStyles> => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
});
